import { render, staticRenderFns } from "./return-reports.vue?vue&type=template&id=6e25a6d0"
import script from "./return-reports.vue?vue&type=script&lang=js"
export * from "./return-reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports